module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_OlivierBlum_Still.c69ce36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_OlivierBlum_Still.jpg
// module id = DgEX
// module chunks = 0